import { createSlice } from "@reduxjs/toolkit";

const userFieldsSlice = createSlice({
  name: "userFields",
  initialState: "",
  reducers: {
    saveUserFields: (state, action) => action.payload,
  },
});

export default userFieldsSlice;
